module.exports = __webpack_public_path__ + "img/interac_icon.d3327bac.png";